"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuotationSocketMgr = exports.getGlobalQuotationSocketMgr = exports.jsonDeserializer = exports.SubscribeEventType = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const WebSocketSubject_1 = require("./base/WebSocketSubject");
const CurrencyPriceWebSocket_1 = require("./CurrencyPriceWebSocket");
const KlineWebSocket_1 = require("./KlineWebSocket");
const MarkPriceWebSocket_1 = require("./MarkPriceWebSocket");
const OrderBookWebSocket_1 = require("./OrderBookWebSocket");
const TickerWebsocket_1 = require("./TickerWebsocket");
const TradesWebSocket_1 = require("./TradesWebSocket");
const FIndexWebsocket_1 = require("./FIndexWebsocket");
var SubscribeEventType;
(function (SubscribeEventType) {
    SubscribeEventType["ticker"] = "tickers.price";
    SubscribeEventType["selectedTicker"] = "selectedTicker";
    SubscribeEventType["orderBook"] = "order.book";
    SubscribeEventType["trade"] = "trades.history";
    SubscribeEventType["currencyPrice"] = "balance.tickers.price";
    SubscribeEventType["markPrice"] = "future.markprice";
    SubscribeEventType["kline"] = "kline";
    SubscribeEventType["fIndex"] = "future.indexes";
})(SubscribeEventType = exports.SubscribeEventType || (exports.SubscribeEventType = {}));
function jsonDeserializer(event) {
    if (event.data) {
        try {
            return JSON.parse(event.data);
        }
        catch (_a) {
            (0, trade_utils_lib_1.getTradeDependencyInstance)().log(trade_utils_lib_1.LogLevel.LEVEL_INFO, QuotationSocketMgr.TAG, `${Date.now()} jsonDeserializer error: ${JSON.stringify(event.data)}`);
        }
    }
    return undefined;
}
exports.jsonDeserializer = jsonDeserializer;
let globalManager;
function getGlobalQuotationSocketMgr() {
    if (globalManager) {
        return globalManager;
    }
    globalManager = new QuotationSocketMgr({});
    return globalManager;
}
exports.getGlobalQuotationSocketMgr = getGlobalQuotationSocketMgr;
class QuotationSocketMgr {
    constructor(initConfig) {
        this.wsUrl = "";
        this.connectionState = trade_utils_lib_1.State.UNKNOWN;
        this.latestSubParamMap = new Map();
        this.appPaused = false;
        this.openObserver = {
            next: (event) => {
                this.connectionState = trade_utils_lib_1.State.DONE;
                this.webSocket = event.target;
                this.onInitStateDone(this.webSocket);
                (0, trade_utils_lib_1.getTradeDependencyInstance)().log(trade_utils_lib_1.LogLevel.LEVEL_INFO, QuotationSocketMgr.TAG, `${Date.now()} websocket opened`);
            },
        };
        this.closeObserver = {
            next: (event) => {
                this.webSocket = undefined;
                this.connectionState = trade_utils_lib_1.State.FAILED;
                const info = `code:${event.code}, reason:${event.reason}, message:${event.message}, appPaused:${this.appPaused}`;
                (0, trade_utils_lib_1.getTradeDependencyInstance)().log(trade_utils_lib_1.LogLevel.LEVEL_INFO, QuotationSocketMgr.TAG, `${Date.now()} websocket closed, ${info}`);
                if (!this.appPaused) {
                    // app处于前台，但是websocket断开了，尝试重连
                    this.reconnect();
                }
            },
        };
        this.webSocketConfig = initConfig;
        this.disableCache = initConfig.disableCache;
        this.websocketInstance = this.getWebSocketSubject();
        this.markPriceWebSocket = new MarkPriceWebSocket_1.MarkPriceWebSocket(initConfig, (channel, param) => {
            this.send(channel, param);
        });
        this.currencyWebSocket = new CurrencyPriceWebSocket_1.CurrencyPriceWebSocket(initConfig, (channel, param) => {
            this.send(channel, param);
        });
        this.tickerWebSocket = new TickerWebsocket_1.TickerWebsocket(initConfig, (channel, param) => {
            this.send(channel, param);
        });
        this.orderBookWebSocket = new OrderBookWebSocket_1.OrderBookWebSocket(initConfig, (channel, param) => {
            this.send(channel, param);
        });
        this.tradesWebSocket = new TradesWebSocket_1.TradesWebSocket(initConfig, (channel, param) => {
            this.send(channel, param);
        });
        this.klineWebSocket = new KlineWebSocket_1.KlineWebSocket(initConfig, (channel, param) => {
            this.send(channel, param);
        });
        this.fIndexWebSocket = new FIndexWebsocket_1.FIndexWebsocket(initConfig, (channel, param) => {
            this.send(channel, param);
        });
        (0, trade_utils_lib_1.getTradeDependencyInstance)().log(trade_utils_lib_1.LogLevel.LEVEL_INFO, QuotationSocketMgr.TAG, `${Date.now()} init start`);
        this.tickerWebSocket.initTickerCachePrepare(this.disableCache);
        this.start();
    }
    send(channel, param) {
        var _a;
        const data = JSON.stringify({
            action: "subscribe",
            channel: channel,
            data: param,
        });
        this.latestSubParamMap.set(channel, data);
        (_a = this.webSocket) === null || _a === void 0 ? void 0 : _a.send(data);
        (0, trade_utils_lib_1.getTradeDependencyInstance)().log(trade_utils_lib_1.LogLevel.LEVEL_INFO, QuotationSocketMgr.TAG, `${channel} ${data}`);
    }
    onAppStateChanged(paused) {
        this.appPaused = paused;
        (0, trade_utils_lib_1.getTradeDependencyInstance)().log(trade_utils_lib_1.LogLevel.LEVEL_INFO, QuotationSocketMgr.TAG, `${Date.now()} onAppStateChanged ${paused ? "background" : "foreground"}`);
        if (this.closeTimeoutId) {
            clearTimeout(this.closeTimeoutId);
        }
        if (paused) {
            this.tickerWebSocket.onAppPause();
            const timeout = 500;
            this.closeTimeoutId = setTimeout(() => {
                (0, trade_utils_lib_1.getTradeDependencyInstance)().log(trade_utils_lib_1.LogLevel.LEVEL_INFO, QuotationSocketMgr.TAG, `${Date.now()} app paused ${timeout}ms, close websocket, current appPaused:${this.appPaused}`);
                this.closeTimeoutId = undefined;
                this.close();
            }, timeout);
        }
        else {
            this.start();
        }
    }
    onInitStateDone(websocket) {
        this.latestSubParamMap.forEach((data) => {
            websocket.send(data);
        });
    }
    getCurrencyPriceWebSocket() {
        return this.currencyWebSocket;
    }
    getTickerWebSocket() {
        return this.tickerWebSocket;
    }
    getOrderBookWebSocket() {
        return this.orderBookWebSocket;
    }
    getTradesWebSocket() {
        return this.tradesWebSocket;
    }
    getMarkPriceWebSocket() {
        return this.markPriceWebSocket;
    }
    getKlineWebSocket() {
        return this.klineWebSocket;
    }
    getFIndexWebSocket() {
        return this.fIndexWebSocket;
    }
    getWebSocketSubject() {
        if (!this.websocketInstance) {
            this.websocketInstance = this.createWebSocketSubject();
        }
        return this.websocketInstance;
    }
    createWebSocketSubject() {
        this.wsUrl = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().webSocketHost}/stream/v2`;
        const wsConfig = {
            url: this.wsUrl,
            openObserver: this.openObserver,
            closeObserver: this.closeObserver,
            deserializer: jsonDeserializer,
        };
        return new WebSocketSubject_1.WebSocketSubject(wsConfig);
    }
    close() {
        if (this.subscription) {
            (0, trade_utils_lib_1.getTradeDependencyInstance)().log(trade_utils_lib_1.LogLevel.LEVEL_INFO, QuotationSocketMgr.TAG, `${Date.now()} close websocket: ${this.wsUrl}`);
            this.subscription.unsubscribe();
            this.subscription = undefined;
            this.webSocket = undefined;
        }
    }
    start() {
        if (this.appPaused) {
            (0, trade_utils_lib_1.getTradeDependencyInstance)().log(trade_utils_lib_1.LogLevel.LEVEL_INFO, QuotationSocketMgr.TAG, `${Date.now()} start ignored, app paused`);
        }
        if (this.subscription) {
            if (this.connectionState !== trade_utils_lib_1.State.DONE) {
                (0, trade_utils_lib_1.getTradeDependencyInstance)().log(trade_utils_lib_1.LogLevel.LEVEL_INFO, QuotationSocketMgr.TAG, `${Date.now()} start ignored, but connectionState is ${this.connectionState}`);
            }
            return;
        }
        this.subscription = (0, trade_utils_lib_1.requestWithRetry)(() => {
            return this.getWebSocketSubject();
        }, { name: "ExchangeWebSocket" }).subscribe({
            next: (data) => {
                if (!data) {
                    return;
                }
                try {
                    switch (data.channel) {
                        case SubscribeEventType.ticker:
                            this.tickerWebSocket.handleTickerData(data.data);
                            break;
                        case SubscribeEventType.orderBook:
                            this.orderBookWebSocket.handleOrderBookData(data.data);
                            break;
                        case SubscribeEventType.trade:
                            this.tradesWebSocket.handleTradeData(data.data);
                            break;
                        case SubscribeEventType.currencyPrice:
                            this.currencyWebSocket.handleCurrencyPriceData(data.data);
                            break;
                        case SubscribeEventType.markPrice:
                            this.markPriceWebSocket.handleMarkPriceData(data.data);
                            break;
                        case SubscribeEventType.kline:
                            this.klineWebSocket.handleKlineData(data.data);
                            break;
                        case SubscribeEventType.fIndex:
                            this.fIndexWebSocket.handleData(data.data);
                            break;
                        default:
                            break;
                    }
                }
                catch (e) {
                    (0, trade_utils_lib_1.getTradeDependencyInstance)().log(trade_utils_lib_1.LogLevel.LEVEL_INFO, QuotationSocketMgr.TAG, `${Date.now()} parse data error: ${JSON.stringify(data)}`);
                }
            },
        });
    }
    reconnect() {
        (0, trade_utils_lib_1.getTradeDependencyInstance)().log(trade_utils_lib_1.LogLevel.LEVEL_INFO, QuotationSocketMgr.TAG, `${Date.now()} reconnect websocket`);
        this.close();
        setTimeout(() => {
            this.start();
        }, 100);
    }
}
exports.QuotationSocketMgr = QuotationSocketMgr;
QuotationSocketMgr.TAG = "quotation";
